import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {MenuLateralAB} from '../menuLateralAA/MenuLateralAB';
import {FormularioEmpresaMiEmpresa} from './FormularioEmpresaMiEmpresa';
import {HeadMiEmpresa} from './HeadMiEmpresa';
import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {Galeria} from './Galeria';
import {ListadoSedes} from './ListadoSedes';
import {MisFacturas} from './MisFacturas';
import {FacturaSimplificada} from './FacturaSimplificada';
import {FacturaCompleta} from './FacturaCompleta';


export const ContentBodyMiEmpresa = (props) => {
	const {MenuLateralAux, chageMenuLateralAux} = props;
	/* Using the useSessionStore hook to get the UsuarioContext from the session storage. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

	const [GaleriaEmpresa, setGaleriaEmpresa] = useState([]);

	const [FotoPerfilCambiar, setFotoPerfilCambiar] = useState();

	/* Setting the state of the TipoNotificaciones variable to an array of strings. */
	const [TipoNotificaciones, setTipoNotificaciones] = useState([
		['buttonNotificacionesActive', 'Mi información'],
		['buttonNotificaciones', 'Galeria'],
		['buttonNotificaciones', 'Sedes'],
		['buttonNotificaciones', 'Mis facturas'],
		['buttonNotificaciones','Factura Simplificada'],
		['buttonNotificaciones','Factura Completa']
	]);

	/**
	 * It takes a number as an argument and then sets the state of the component to a list of strings,
	 * where the string at the index of the number argument is set to a different string
	 */
	const cambioNotificaciones = (num) => {
		let listaAxu = [
			['buttonNotificaciones', 'Mi información'],
			['buttonNotificaciones', 'Galeria'],
			['buttonNotificaciones', 'Sedes'],
			['buttonNotificaciones', 'Mis facturas'],
			['buttonNotificaciones','Factura Simplificada'],
			['buttonNotificaciones','Factura Completa']
		];
		listaAxu[num] = ['buttonNotificacionesActive', listaAxu[num][1]];
		setTipoNotificaciones(listaAxu);
	};

	const [empresa, setEmpresa] = useState({
		idEmpresa: '-------',
		nombreEmpresa: 'nombreEmpresSa',
		nombreContactoEmpresa: 'nombreContactoEmpresa',
		apellidosContactoEmpresa: 'apellidosContactoEmpresa',
		constraseña: 'constraseña',
		repitaConstraseña: 'repitaConstraseña',
		telefono: '666666666',
		direccion: 'direccion',
		codigoPostal: 'codigoPostal',
		webEmpresa: 'webEmpresa',
		emailEmpresa: 'emailEmpresa',
		tamañoEmpresa: '0',
		shareCare: true,
		descripcionEmpresa: 'descripcionEmpresa',
		notasEmpresa: 'notasEmpresa',
	});

	const [sedes, setSedes] = useState();

	const get_sedes = () => {
		if (empresa)
			axios({
				method: 'get',
				url: window.ipdirection + 'sedePrestador/?idempresa=' + empresa.id,
				headers: {
					Authorization: 'Bearer ' + Usuario.access,
				},
			}).then((response) => {
				setSedes(response.data);
			});
	};

	/*
        const descargarArchivos = (documentos) => {
            let lista = [];
            documentos.map(doc => {
                axios(window.ipdirection+'documentoByEmpresaIMG/' + doc.id + '/', {
                    method: 'GET',
                    headers: {
                        "Authorization": "Bearer " + Usuario.access
                    },
                    responseType: 'blob'
                }).then((response) => {
                    lista.push({
                        archivo: URL.createObjectURL(response.data),
                        nombre: doc.nombre,
                        id: doc.id,
                    });
                })
            })
            setListaArchivos(lista);
        }
        */
	const getDatEmpresa = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'prestadorServicios/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		}).then((response) => {
			// Introduciomos los datos del presatador de servicios al usuario
			setEmpresa(response.data[0]);
		});
	};

	const comparadorNombre = (a, b) => {
		if (a.nombre < b.nombre) {
			return -1;
		}
		if (a.nombre > b.nombre) {
			return 1;
		}
		return 0;
	};
	const ordenarLista = (lista) => {
		return lista.sort(comparadorNombre);
	};

	const getGaleriaEmpresa = () => {
		setGaleriaEmpresa([]);
		axios({
			method: 'get',
			url: window.ipdirection + 'galeriaEmpresa/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				let lista = [];
				response.data.forEach((element) => {
					let nombre = element.nombre;
					axios({
						method: 'get',
						url: window.ipdirection + 'galeriaEmpresa/' + element.id + '/',
						headers: {
							Authorization: 'Bearer ' + Usuario.access,
						},
						responseType: 'blob',
					}).then((response) => {
						lista.push({
							url: URL.createObjectURL(response.data),
							nombre: element.nombre,
							id: element.id,
						});
						setGaleriaEmpresa([...ordenarLista(lista)]);
					});
				});
			})
			.catch((error) => {
				console.log(error);
			});
	};

	useEffect(() => {
		getDatEmpresa();
		getGaleriaEmpresa();
	}, []);

	useEffect(() => {
		get_sedes();
	}, [empresa]);

	const [modificar, setModificar] = useState(false);

	return (
		<>
			<MenuLateralAB
				seleccionado={0}
				MenuLateralAux={MenuLateralAux}
				chageMenuLateralAux={chageMenuLateralAux}
			/>
			<div className='derContentMiEmpresa'>
				<HeadMiEmpresa
					TipoNotificaciones={TipoNotificaciones}
					cambioNotificaciones={cambioNotificaciones}
				/>
				{TipoNotificaciones[0][0] === 'buttonNotificacionesActive' ? (
					<FormularioEmpresaMiEmpresa
						empresa={empresa}
						modificar={modificar}
						setModificar={setModificar}
						FotoPerfilCambiar={FotoPerfilCambiar}
						setEmpresa={setEmpresa}
					/>
				) : (
					<></>
				)}
				{TipoNotificaciones[1][0] === 'buttonNotificacionesActive' ? (
					<Galeria
						getGaleriaEmpresa={getGaleriaEmpresa}
						GaleriaEmpresa={GaleriaEmpresa}
						empresa={empresa}
					/>
				) : (
					<></>
				)}
				{TipoNotificaciones[2][0] === 'buttonNotificacionesActive' ? (
					<ListadoSedes
						empresa={empresa}
						sedes={sedes}
						get_sedes={get_sedes}
						// FotoPerfilCambiar={FotoPerfilCambiar}
						// setEmpresa={setEmpresa}
					/>
				) : (
					<></>
				)}
				{TipoNotificaciones[3][0] === 'buttonNotificacionesActive' ? (
					<MisFacturas
						empresa={empresa}
						Usuario={Usuario}
					/>
				) : (
					<></>
				)}
				{TipoNotificaciones[4][0] === 'buttonNotificacionesActive' ? (
					<FacturaSimplificada
						empresa={empresa}
						Usuario={Usuario}
					/>
				) : (
					<></>
				)}
				{TipoNotificaciones[5][0] === 'buttonNotificacionesActive' ? (
					<FacturaCompleta
						empresa={empresa}
						Usuario={Usuario}
					/>
				) : (
					<></>
				)}
			</div>
		</>
	);
};
